import Ansi from "@cocalc/ansi-to-react";
import type { FC } from "react";
import { useLoaderData } from "react-router-dom";

const OptimistTraceRoute: FC = () => {
  const trace = useLoaderData() as string;

  return (
    <pre className="bg-gray-950 rounded-sm text-sm font-mono p-4 overflow-x-scroll">
      <Ansi>{trace}</Ansi>
    </pre>
  );
};

export default OptimistTraceRoute;
